import { isValidPhoneNumber } from 'libphonenumber-js'

export const validatePhoneNumber = value => {
    return !!value && isValidPhoneNumber(value)
}
